import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const CreditCardFront = ({ cardBrand, number, personName, validityDate }) => {
  const brand = cardBrand()
  const personNameFormat = personName.substr(0, 20)
  return (
    <Fragment>
      <span className='front_credit-card brand_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'>
        {brand && brand.name ? (
          <img src={brand.imageUrl} alt={brand.name} />
        ) : (
          ''
        )}
      </span>
      <span className='front_credit-card number_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'>
        {number || '**** **** **** ****'}
      </span>
      <span className='front_credit-card name_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'>
        {personNameFormat || 'Nome e Sobrenome'}
      </span>
      <span className='front_credit-card date_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'>
        {validityDate || '00/00'}
      </span>
    </Fragment>
  )
}

CreditCardFront.propTypes = {
  number: PropTypes.string.isRequired,
  personName: PropTypes.string.isRequired,
  validityDate: PropTypes.string.isRequired,
  cardBrand: PropTypes.func.isRequired
}

export default CreditCardFront



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/CreditCardFront.js